/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { GetSelfEmployedFinanceQueryResponse, GetSelfEmployedFinance400, GetSelfEmployedFinance401, GetSelfEmployedFinance500 } from "../entities/GetSelfEmployedFinance";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getSelfEmployedFinance } from "../api/getSelfEmployedFinance";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getSelfEmployedFinanceQueryKey = () => [{ url: '/api/v1/self-employed/finance' }] as const

export type GetSelfEmployedFinanceQueryKey = ReturnType<typeof getSelfEmployedFinanceQueryKey>

export function getSelfEmployedFinanceQueryOptions(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getSelfEmployedFinanceQueryKey()
        return queryOptions<GetSelfEmployedFinanceQueryResponse, ResponseErrorConfig<GetSelfEmployedFinance400 | GetSelfEmployedFinance401 | GetSelfEmployedFinance500>, GetSelfEmployedFinanceQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return getSelfEmployedFinance({ ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Возвращает данные для экрана вывода: доступность вывода, баланс, удержания за месяц, банк СБП и остаток на счёте партнёра.
 * Последние операции в ответ не входят: фронт берёт их отдельным запросом
 * `GET /api/v1/self-employed/transactions?limit=3`.
 * Фронт выбирает состояние экрана по этому ответу. Отдельной публичной ручки статуса СМЗ в сервисе нет.
 * У нового водителя нет счёта СБП: это не ошибка, ответ `200` с нулевыми суммами и `payout_method = null`.
 * **Состояния экрана:**
 * - активный водитель: `withdrawal.is_available = true`
 * - недоступна ФНС: `withdrawal.unavailable_reason = fns_unavailable`
 * - статус СМЗ утерян: `withdrawal.unavailable_reason = self_employed_status_lost`
 * - нет статуса СМЗ: `withdrawal.unavailable_reason = not_self_employed`
 * - нет счёта СБП: `withdrawal.unavailable_reason = no_sbp_account`, `payout_method = null`
 * Если причин несколько, сервер отдаёт первую по списку выше: `fns_unavailable`,
 * `self_employed_status_lost`, `not_self_employed`, `no_sbp_account`.
 * Отсутствие счёта СБП фронт видит по `payout_method = null` и при других причинах:
 * в макете «Подтвердите самозанятость» показывают вместе с «Добавить счет СБП».
 * **Требования:**
 * - JWT access-токен водителя (`Authorization: Bearer`). Водитель определяется по токену,
 * заголовки `user-id` и `city-id` не нужны
 * **Процесс:**
 * 1. Определение доступности вывода: доступность ФНС, статус СМЗ, счёт СБП
 * 2. Получение баланса, привязанного банка СБП и признака остатка на счёте партнёра
 * 3. Возврат данных экрана
 * **Пояснение по объектам:**
 * - withdrawal: можно ли вывести средства и почему нельзя
 * - is_available: вывод доступен
 * - unavailable_reason: причина недоступности. Обязательна при `is_available = false`
 * - balance: суммы в копейках
 * - available: доступно для вывода
 * - upcoming: скоро зачислятся
 * - deducted_this_month: комиссия Drivee с НДС, удержанная с заказов за текущий календарный месяц, в копейках. Месяц считается по часовому поясу города водителя
 * - payout_method: способ вывода. `null`, если счёта СБП нет — экран «Добавить счет СБП»
 * - bank_id: ID банка из `GET /api/v1/account/sbp-banks`
 * - bank_name: название банка
 * - bank_icon_url: логотип банка. `null`, если логотипа нет
 * - phone: полный номер телефона СБП в формате E.164 для шторки подтверждения, без маски
 * - email: почта для месячных чеков СМЗ. `null`, если почта не привязана
 * - method: метод вывода средств, сейчас только `sbp`
 * - partner_account.has_balance: на счёте партнёра остались деньги. Блок «На счете партнера» показывают при `true` и убирают после вывода (`false`)
 * @summary Данные экрана вывода средств для СМЗ
 * {@link /api/v1/self-employed/finance}
 */
export function useGetSelfEmployedFinance<TData = GetSelfEmployedFinanceQueryResponse, TQueryData = GetSelfEmployedFinanceQueryResponse, TQueryKey extends QueryKey = GetSelfEmployedFinanceQueryKey>(options: 
{
  query?: Partial<QueryObserverOptions<GetSelfEmployedFinanceQueryResponse, ResponseErrorConfig<GetSelfEmployedFinance400 | GetSelfEmployedFinance401 | GetSelfEmployedFinance500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? getSelfEmployedFinanceQueryKey()
         

         const query = useQuery({
          ...getSelfEmployedFinanceQueryOptions(config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetSelfEmployedFinance400 | GetSelfEmployedFinance401 | GetSelfEmployedFinance500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}